import { Injectable, OnDestroy } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { Conciergerie } from 'app/models/conciergerie.model';
import { UserService } from 'app/services/user.service';
import { ToastService } from 'app/services/toast.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements OnDestroy  {

  private subscription: Subscription;
  private conciergerie: Conciergerie;
  private conciergerie_id: string = localStorage.getItem('conciergerie_id');

  constructor(private router: Router, private userService: UserService, private toastService: ToastService) {
    const conciergerieJson: string = localStorage.getItem('conciergerie');

    if (conciergerieJson) {
      const conciergerie: any = JSON.parse(conciergerieJson);

      if (conciergerie && conciergerie.id == this.conciergerie_id) {
        this.conciergerie = conciergerie;
      }
    }

    this.subscription = this.userService.getConciergerie().subscribe((conciergerie: Conciergerie): void => {
      this.conciergerie = conciergerie;
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (this.conciergerie?.is_admin) {
      return true;
    }

    this.toastService.error('error.not-admin');
    this.router.navigate(['/conciergerie/home']);

    return false;
  }

}
